export default {"src":"/org/_next/static/media/clock.3ab43390.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};